import React, { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { Button, Drawer, ListItem } from '@material-ui/core'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import './ProductCard.css'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import CommonContext from '@/product/context/common/commonContext'
import { useFormik } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { handleRedirectInternal } from '@/custom/common/components'
import SignContext from '@/custom/context/signContext'
import { dateTimeFormatFunction, dateTimeFormatFunctionNew } from '@/custom/common/components'
import Timer from '@/custom/common/timer'
import { FALLBACK_IMAGE } from '@/utils'
// import Timer from '@/product/common/timer'
import AuthContext from '@/product/context/auth/authContext'
const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})

function AuctionCard(props) {
    const commonContext = useContext(CommonContext)
    const { setSearchValue, allLocations } = commonContext
    const [auction, setAuction] = useState({})
    const [deleteConfirmationPopup, setDeleteConfirmationPopup] = useState(false)
    const history = useHistory()
    const classes = useStyles()
    const customCommonContext = useContext(CustomCommonContext)
    const { alldata_all_dropdown } = customCommonContext
    const [state, setState] = useState({
        bottom: false,
    })
    const { loginPopup, handleLoginPopup, handleKycPopup, kycPopup } = useContext(SignContext)
    useEffect(() => {
        setAuction(props.data)
    }, [props.data])

    const formik = useFormik({
        initialValues: {
            auctionid: '',
        },
    })
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const auctionRedirect = (id) => {
        history.push({
            pathname: '/liveAuction/' + id,
            state: auction,
        })
        window.scrollTo(0, 0)
    }

    // const handleRedirectInternal = (path) => {
    //     history.push(`/${path}`)
    //     window.scrollTo(0, 0)
    // }
    const handleDeleteConfirm = () => {
        setDeleteConfirmationPopup(!deleteConfirmationPopup)
    }

    const handleClose = (state) => {
        state(false)
    }

    const handleOpen = (state) => {
        state(true)
    }

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }
    const dateAddedReached = (data) => {
        if (auction.future_active) {
            if (data) {
                setAuction({ ...auction, future_active: 0 })
            }
        }
    }

    return (
        <>
            {' '}
            <div className="auctionCard d-flex justify-content-between align-items-stretch customCard">
                <div className="auctionCardLt d-flex">
                    <div className="acImg">
                        <img
                            src={`${global.site_url}/uploads/auction/${auction.avatar}`}
                            onError={(e) => FALLBACK_IMAGE(e)}
                            alt="Live Auction"
                        />
                    </div>
                    <div className="acContent">
                        <h3
                            className={`${
                                auction.future_active
                                    ? 'upType'
                                    : auction.market_status == 'closed'
                                    ? 'acType'
                                    : 'acType'
                            }`}
                        >
                            {auction.sale_type == 'PT'
                                ? 'Private Treaty'
                                : auction.sale_type == 'R'
                                ? 'Reverse Auction'
                                : 'Online Auction'}
                        </h3>
                        <h2>{auction.title?.charAt(0).toUpperCase() + auction.title?.slice(1)}</h2>
                        {/* <p className="acAddress mb-0">
                            <p
                                className="mb-0"
                                dangerouslySetInnerHTML={{
                                    __html: auction.description,
                                }}
                            ></p>
                        </p> */}
                        <a
                            target="_blank"
                            href={
                                auction.catalogue
                                    ? `${process.env.REACT_APP_DOMAIN}/uploads/catalogue/${auction.catalogue}`
                                    : process.env.REACT_APP_FRONTURL
                                    ? `${process.env.REACT_APP_FRONTURL}/catalog/${auction.id}`
                                    : null
                            }
                            rel="noopener noreferrer"
                            className="reg-btn text-decoration-none"
                        >
                            <p className="acStartDate bttnLink">
                                <span className="d-flex" style={{ gap: '5px' }}>
                                    <span className="p-0">
                                        {
                                            alldata_all_dropdown[
                                                alldata_all_dropdown?.findIndex(
                                                    (ele) => ele.id == auction.category,
                                                )
                                            ]?.description
                                        }
                                    </span>
                                </span>
                                <span className="btnLi d-flex">
                                    <span className="material-icons p-0">calendar_month</span>
                                    {'View catalogue'}
                                </span>
                            </p>
                        </a>
                        <hr className="mt-2 mb-2" />
                        <p className="acStartDate w-100">
                            <span>{'Auction Id'}:</span>
                            {auction.id} | {auction.all_projects_count} Lots
                        </p>
                        <p className="acStartDate zoneLoc">
                            <span
                                className="material-icons"
                                style={{ fontStyle: 'normal', padding: '0' }}
                            >
                                location_on
                            </span>
                            <span>{'Assets Location:'}</span>
                            {auction.auction_location || ''}
                        </p>
                        <hr className="mt-2 mb-2" />
                        <p className="acStartDate d-flex align-items-center">
                            <span className="material-icons p-0">calendar_month</span>{' '}
                            {dateTimeFormatFunctionNew(auction.date_added)}&nbsp;&nbsp;
                            <span>{'to'}</span>
                            {dateTimeFormatFunctionNew(auction.date_closed)}
                        </p>
                    </div>
                </div>

                <div className="acActBtn">
                    <div className="acTimer d-flex justify-content-center align-items-center flex-wrap">
                        <h6
                            className={`${
                                auction.future_active
                                    ? 'upComing'
                                    : auction.market_status == 'closed'
                                    ? 'Closed'
                                    : 'onGoing'
                            }`}
                        >
                            {auction.future_active
                                ? 'Upcoming'
                                : auction.market_status == 'closed'
                                ? 'Closed'
                                : 'Ongoing'}
                        </h6>
                        {auction.market_status == 'open' ? (
                            <h6
                                className={`${
                                    auction.future_active ? 'timeLeftUpComing' : 'timeLeft'
                                }`}
                            >
                                <span className="material-icons-outlined mr-2">timer</span>
                                {auction.future_active ? 'Starts In' : 'Time Left'}
                            </h6>
                        ) : null}
                        <div
                            className={`${
                                auction.future_active
                                    ? 'timerClockUpComing'
                                    : auction.market_status == 'closed'
                                    ? 'timerClockClosed'
                                    : 'timerClock'
                            }`}
                        >
                            {auction.date_closed ? (
                                <Timer
                                    date_added_check={auction.future_active}
                                    date_added_reached={dateAddedReached}
                                    date_added={auction.date_added}
                                    date_closed={auction.date_closed}
                                    withText={0}
                                    endText={'Time left' + ':'}
                                    startText={'starts in' + ':'}
                                ></Timer>
                            ) : null}
                        </div>

                        <div
                            className={`d-flex ${
                                auction.future_active ? 'listButtonup' : 'listButton'
                            }`}
                            style={{ gap: '10px' }}
                        >
                            <PrimaryButton
                                id="view_auctionCard"
                                onClick={() => {
                                    if (!isAuthenticated) {
                                        handleLoginPopup()
                                    } else if (user && !user.is_kyc_done) {
                                        handleKycPopup()
                                    } else {
                                        auctionRedirect(auction.id)
                                        // handleRedirectInternal(history, `checkout/${auction.id}`)
                                    }
                                }}
                                label={auction.future_active ? 'Register' : 'Bid Now'}
                                btnSize="small"
                            />
                            <PrimaryButton
                                id="view_auctionCard"
                                onClick={() => auctionRedirect(auction.id)}
                                label="View Lot"
                                btnSize="small"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AuctionCard
